import { useStore } from "@tanstack/react-store";
import { useContext } from "react";

import { StoreContext } from "./StoreProvider";
import type { StoreState } from "./types";

export const useAppStore = <T>(selector: (state: StoreState) => T) => {
  const store = useContext(StoreContext);

  if (!store) {
    throw new Error("useAppStore must be used within StoreProvider");
  }

  return useStore(store, selector);
};
